// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"67b33a9f","413":"6bd639ca","465":"eec7ebfe","800":"bf8534fe","860":"3e2c6dcc"}[chunkId] + ".chunk.css";
};